import sensors from "./sensors_config";

//Part 1 登录注册流程
/**
 * 浏览注册页时触发
 * 登录注册页浏览
 * @param {String} current_page 当前页面:登录页、注册页
 * @param {String} entrance_source 来源入口:首页、游戏账号详情页、担保中介收费明细页
 * @param {String} source_page 来源页面:传名称，url通过开启$预置属性采集
 */
const RegisterSignPageView = (current_page, entrance_source, source_page) => {
  sensors.track('RegisterSignPageView', {
    current_page,
    entrance_source,
    source_page,
  });
}

/**
 * 点击注册按钮时触发
 * 提交注册信息
 * @param {String} register_mobile 注册手机号
 */
const SubRegister = (register_mobile) => {
  sensors.track('SubRegister', {
    register_mobile: register_mobile + ''
  });
}

//Part 2 官网寄售流程
/**
 * 进入官网【寄售页面】时触发
 * 进入官方寄售页面
 * @param {String} source_page 前向来源:个人中心-我要卖、弹窗-官网寄售
 */
const AccSellView = (source_page) => {
  sensors.track('AccSellView', {
    source_page
  });
}

/**
 * 点击游戏icon时触发
 * 选择寄售游戏
 * @param {String} game_id 游戏ID
 * @param {String} game_name 游戏名称
 * @param {Boolean} is_search_click 是否搜索结果点击
 * @param {String} original_key_word 搜索原始词
 */
const SellGameSelect = (game_id, game_name, is_search_click, original_key_word) => {
  sensors.track('SellGameSelect', {
    game_id: game_id + '',
    game_name,
    is_search_click: is_search_click || false,
    original_key_word,
  });
}

/**
 * 点击-下一步填写信息时触发
 * 补充商品基本信息
 * @param {String} game_id 游戏ID
 * @param {String} game_name 游戏名称
 * @param {String} product_type_id 商品类型ID
 * @param {String} product_type 商品类型
 */
const AddProductBasicInformation = (game_id, game_name, product_type_id, product_type) => {
  sensors.track('AddProductBasicInformation', {
    game_id: game_id + '',
    game_name,
    product_type_id: product_type_id + '',
    product_type: product_type + '',
  });
}

/**
 * 点击立即发布时触发
 * 补充商品详细信息
 * @param {String} source_page 前向来源:估价报告、一键寄售
 * @param {String} screenshot_type 截图方式:游严选官网截图、自主截图
 * @param {Number} sell_price 售价
 * @param {String} account_source 账号来源:自己注册、游严选平台购买、其他渠道购买
 * @param {Boolean} accept_bargaining 是否接受议价:接受、不接受
 * @param {Number} is_buy_sincere_service 是否购买诚心卖:1-购买、0-不购买
 * @param {String} product_type 商品类型:装备道具、游戏账号（具体的类型是ID对应的枚举值）
 * @param {String} product_type_id 商品类型ID
 * @param {String} game_id 游戏ID
 * @param {String} game_name 游戏名称
 * @param {String} status 发布成功/失败状态

 */
const AddProductDetailInformation = (source_page, screenshot_type, sell_price, account_source, accept_bargaining,
                                     is_buy_sincere_service, product_type, product_type_id, game_id, game_name, status) => {
  sensors.track('AddProductDetailInformation', {
    source_page,
    screenshot_type,
    sell_price: sell_price * 1,
    account_source,
    accept_bargaining,
    is_buy_sincere_service,
    product_type: product_type + '',
    product_type_id: product_type_id + '',
    game_id: game_id + '',
    game_name,
    status
  });
}

//Part 3 担保中介流程
/**
 * 进入【担保中介】页面时触发
 * 进入担保中介页面
 * @param {String} source_page 前向来源:担保中介、弹窗-担保中介
 */
const VouchView = (source_page) => {
  sensors.track('VouchView', {
    source_page
  });
}

/**
 * 点击游戏icon时触发
 * 选择担保游戏
 * @param {String} game_id 游戏ID
 * @param {String} game_name 游戏名称
 * @param {Boolean} is_search_click 是否搜索结果点击
 * @param {String} original_key_word 搜索原始词
 */
const VouchGameSelect = (game_id, game_name, is_search_click, original_key_word) => {
  sensors.track('VouchGameSelect', {
    game_id: game_id + '',
    game_name,
    is_search_click: is_search_click || false,
    original_key_word,
  });
}

//Part 4 账号回收流程
/**
 * 进入【账号回收】页面时触发
 * 进入账号回收页面
 * @param {String} source_page 前向来源:账号回收、弹窗-号商回收
 */
const AccRecycleView = (source_page) => {
  sensors.track('AccRecycleView', {
    source_page,
  });
}

/**
 * 点击游戏icon时触发
 * 选择回收游戏
 * @param {String} game_id 游戏ID
 * @param {String} game_name 游戏名称
 * @param {Boolean} is_search_click 是否搜索结果点击
 * @param {String} original_key_word 搜索原始词
 */
const RecycleGameSelect = (game_id, game_name, is_search_click, original_key_word) => {
  sensors.track('RecycleGameSelect', {
    game_id: game_id + '',
    game_name,
    is_search_click: is_search_click || false,
    original_key_word,
  });
}

/**
 * 账号回收页面-点击号商详情时触发
 * 选择号商
 * @param {String} game_id 游戏ID
 * @param {String} game_name 游戏名称
 * @param {String} vendors_id 号商ID
 * @param {String} vendors_name 号商名称
 */
const VendorsSelect = (game_id, game_name, vendors_id, vendors_name) => {
  sensors.track('VendorsSelect', {
    game_id: game_id + '',
    game_name,
    vendors_id: vendors_id + '',
    vendors_name,
  });
}

//Part 5 账号估价流程
/**
 * 进入【账号估价】页面时触发
 * 进入账号估价页面
 * @param {String} source_page 进入账号估价页面:估价报告-继续估价、账号估价
 */
const AccValuationView = (source_page) => {
  sensors.track('AccValuationView', {
    source_page,
  });
}

/**
 * 点击游戏icon时触发
 * 选择估价游戏
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 */
const ValuationGameSelect = (game_name, game_id) => {
  sensors.track('ValuationGameSelect', {
    game_name,
    game_id: game_id + '',
  });
}

/**
 * 账号估价页面-点击立即发布时触发
 * 填写估价信息
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {Array} information_list 信息列表
 */
const AddValuationInformation = (game_name, game_id, information_list) => {
  sensors.track('AddValuationInformation', {
    game_name,
    game_id: game_id + '',
    information_list,
  });
}

/**
 * 进入估价成功页面时触发
 * 提交估价信息成功
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {Array} information_list 信息列表
 */
const SubmitValuationSuccess = (game_name, game_id, information_list) => {
  sensors.track('SubmitValuationSuccess', {
    game_name,
    game_id: game_id + '',
    information_list,
  });
}

/**
 * 点击一键寄售时触发
 * 点击一键寄售
 * @param {String} valuation_report_id 报告ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {Number} pre_market_price 预估市场价格
 * @param {String} information_list 信息列表
 * @param {String} customer_service_id 客服ID
 * @param {String} customer_service_name 客服名称
 */
const SellClick = (valuation_report_id, game_name, game_id, pre_market_price, information_list, customer_service_id, customer_service_name) => {
  sensors.track('SellClick', {
    valuation_report_id,
    game_name,
    game_id: game_id + '',
    pre_market_price: pre_market_price * 1,
    information_list,
    customer_service_id: customer_service_id + '',
    customer_service_name,
  });
}

/**
 * 点击继续估价时触发
 * 点击继续估价
 * @param {String} valuation_report_id 报告ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {Number} pre_market_price 预估市场价格
 * @param {String} information_list 信息列表
 * @param {String} customer_service_id 客服ID
 * @param {String} customer_service_name 客服名称
 */
const ContinueValuationClick = (valuation_report_id, game_name, game_id, pre_market_price, information_list, customer_service_id, customer_service_name) => {
  sensors.track('ContinueValuationClick', {
    valuation_report_id: valuation_report_id + '',
    game_name,
    game_id: game_id + '',
    pre_market_price: pre_market_price * 1,
    information_list,
    customer_service_id: customer_service_id + '',
    customer_service_name,
  });
}

//Part 6 买号流程
/**
 * 点击个人中心-我要买或者账号交易-我要买号时触发
 * 进入全部游戏页面
 * @param {String} source_page 前向来源:个人中心-我要买、账号交易-我要买号、全部页面
 */
const AllGameView = (source_page) => {
  sensors.track('AllGameView', {
    source_page,
  });
}

/**
 * 点击游戏icon时触发
 * 选择买号游戏
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 */
const BuyGameSelect = (game_name, game_id) => {
  sensors.track('BuyGameSelect', {
    game_name,
    game_id: game_id + '',
  });
}

/**
 * 点击商品类型时触发
 * 选择商品类型
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} product_type 商品类型:装备道具、游戏账号（具体的类型是ID对应的枚举值）
 * @param {String} product_type_id 商品类型ID
 */
const ProductTypeSelect = (game_name, game_id, product_type, product_type_id) => {
  sensors.track('ProductTypeSelect', {
    game_name,
    game_id: game_id + '',
    product_type,
    product_type_id: product_type_id + '',
  });
}

/**
 * 每次点击筛选条件时触发
 * 普通筛选
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} product_type 商品类型:装备道具、游戏账号（具体的类型是ID对应的枚举值）
 * @param {String} product_type_id 商品类型ID
 * @param {String} screen_title 筛选标题
 * @param {String} screen_value 筛选值
 */
const NormalScreen = (game_name, game_id, product_type, product_type_id, screen_title, screen_value) => {
  sensors.track('NormalScreen', {
    game_name,
    game_id: game_id + '',
    product_type,
    product_type_id: product_type_id + '',
    screen_title,
    screen_value,
  });
}

/**
 * 每次点击筛选条件时触发
 * 高级筛选
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} product_type 商品类型:装备道具、游戏账号（具体的类型是ID对应的枚举值）
 * @param {String} product_type_id 商品类型ID
 * @param {String} screen_title 筛选标题
 * @param {String} screen_value 筛选值
 */
const AdvancedScreen = (game_name, game_id, product_type, product_type_id, screen_title, screen_value) => {
  sensors.track('AdvancedScreen', {
    game_name,
    game_id: game_id + '',
    product_type,
    product_type_id: product_type_id + '',
    screen_title,
    screen_value,
  });
}

/**
 * 点击诚心卖筛选条件时触发
 * 筛选诚心卖
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} product_type 商品类型:装备道具、游戏账号（具体的类型是ID对应的枚举值）
 * @param {String} product_type_id 商品类型ID
 * @param {String} screen_value 筛选值
 */
const SellSincereScreen = (game_name, game_id, product_type, product_type_id, screen_value) => {
  sensors.track('SellSincereScreen', {
    game_name,
    game_id: game_id + '',
    product_type,
    product_type_id: product_type_id + '',
    screen_value,
  });
}

/**
 * 点击筛选按钮时触发
 * 筛选价格
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} product_type 商品类型:装备道具、游戏账号（具体的类型是ID对应的枚举值）
 * @param {String} product_type_id 商品类型ID
 * @param {Number} max_price 最高价
 * @param {Number} min_price 最低价
 */
const PriceScreen = (game_name, game_id, product_type, product_type_id, max_price, min_price) => {
  sensors.track('PriceScreen', {
    game_name,
    game_id: game_id + '',
    product_type,
    product_type_id: product_type_id + '',
    max_price: max_price === '' ? null : max_price * 1,
    min_price: min_price === '' ? null : min_price * 1,
  });
}

/**
 * 勾选顶级账号时触发
 * 筛选顶级账号
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} product_type 商品类型:装备道具、游戏账号（具体的类型是ID对应的枚举值）
 * @param {String} product_type_id 商品类型ID
 * @param {Boolean} is_check 是否勾选
 */
const TopAccScreen = (game_name, game_id, product_type, product_type_id, is_check) => {
  sensors.track('TopAccScreen', {
    game_name,
    game_id: game_id + '',
    product_type,
    product_type_id: product_type_id + '',
    is_check,
  });
}

/**
 * 进入商品详情页时触发
 * 进入商品详情页
 * @param {string} source_page 前向来源
 * @param {Number} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} seller_id 卖方ID
 * @param {Boolean} is_vendors 是否号商
 * @param {Boolean} is_search 是否搜索
 */
const ProductDetailView = (source_page, product_id, game_name, game_id, seller_id, is_vendors, is_search) => {
  sensors.track('ProductDetailView', {
    source_page: source_page + '',
    product_id: product_id + '',
    game_name,
    game_id: game_id + '',
    seller_id: seller_id + '',
    is_vendors,
    is_search,
  });
}

/**
 * 进入商品详情页时触发
 * 进入商品详情页
 * @param {String} operation_type 操作类型:求降价、立即购买、点击收藏、点击分享
 * @param {String} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} seller_id 卖方ID
 * @param {Boolean} is_vendors 是否号商
 */
const ProductDetailOperation = (operation_type, product_id, game_name, game_id, seller_id, is_vendors) => {
  sensors.track('ProductDetailOperation', {
    operation_type,
    product_id: product_id + '',
    game_name,
    game_id: game_id + '',
    seller_id: seller_id + '',
    is_vendors,
  });
}

//Part 7 客服
/**
 * 点击【咨询客服】时触发
 * 咨询客服
 * @param {String} current_page 当前页面:担保中介、游戏详情页
 * @param {Number} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} customer_service_id 客服ID
 * @param {String} customer_service_name 客服名称
 */
const ConsultCustomer = (current_page, product_id, game_name, game_id, customer_service_id, customer_service_name) => {
  sensors.track('ConsultCustomer', {
    current_page,
    product_id,
    game_name,
    game_id: game_id + '',
    customer_service_id: customer_service_id + '',
    customer_service_name,
  });
}

/**
 * 收到客服第一条非自动回复时计算时长
 * 收到客服回复
 * @param {Number} first_reply_time 首条回复时长:非自动回复客户首条时间-客户首条时间，取绝对值
 * @param {String} customer_service_id 客服ID
 * @param {String} customer_service_name 客服名称
 */
const CustomerServiceReply = (first_reply_time, customer_service_id, customer_service_name) => {
  sensors.track('CustomerServiceReply', {
    first_reply_time: first_reply_time * 1,
    customer_service_id: customer_service_id + '',
    customer_service_name,
  });
}

//Part 8 搜索
/**
 * 点击搜索栏时触发
 * 点击【游戏】搜索栏
 * @param {String} current_page 当前页面
 */
const GameSearchClick = (current_page) => {
  sensors.track('GameSearchClick', {
    current_page
  });
}

/**
 * 点击搜索结果时触发
 * 点击搜索结果
 * @param {String}original_key_word 搜索原始词
 * @param {String}game_name 游戏名称
 * @param {String}game_id 游戏ID
 * @param {String}product_id 商品ID
 * @param {String}product_number 商品序列号
 */
const SearchResultClick = (original_key_word, game_name, game_id, product_id, product_number) => {
  sensors.track('SearchResultClick', {
    original_key_word,
    game_name,
    game_id: game_id + '',
    product_id: product_id + '',
    product_number: product_number + '',
  });
}

//Part 9 分享
/**
 * 分享H5页面时触发
 * 分享成功
 * @param {String} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} share_interval 分享时间
 * @param {String} game_id 游戏ID
 */
const ShareSuccess = (product_id, game_name, share_interval, game_id) => {
  sensors.track('ShareSuccess', {
    product_id: product_id + '',
    game_name,
    share_interval: share_interval + '',
    game_id: game_id + '',
  });
}

/**
 * 弹出分享二维码时触发
 * 点击分享链接
 * @param {String} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} share_id 分享者ID
 */
const ShareUrlClick = (product_id, game_name, game_id, share_id) => {
  sensors.track('Productdetail_Sharebutton_Click', {
    product_id: product_id + '',
    game_name,
    game_id: game_id + '',
    share_id: share_id + '',
  });
}

/**
 * 被分享者点击分享链接进入页面时触发
 * 点击分享（被分享者）
 * @param {String} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 */
const SharedClick = (product_id, game_name, game_id) => {
  sensors.track('SharedClick', {
    product_id: product_id + '',
    game_name,
    game_id: game_id + '',
  });
}

//Part 10 核心按钮点击
// 注：1、一级按钮：网站首页、全部游戏、账号交易、担保中介、交易必看、交易保障、帮助中心、关于我们
// 2、二级按钮：我要买号、我要卖号、账号回收、业务介绍、服务协议、评价计分、投诉建议、找回赔偿、法务介绍、售后服务、售后案例、防骗提醒
// 比如，用户点击的是【我要买号】按钮，那一级按钮就传‘账号交易’，二级按钮就传‘我要买号’；用户点击的是【担保中介】按钮，那一级按钮就传‘担保中介’，二级按钮就传空
// 3、官网首页banner点击（轮播图）
/**
 * 点击官网首页上方的的一级按钮/二级按钮时触发
 * 官网_首页按钮点击
 * @param {String} first_button 一级按钮名称
 * @param {String} second_button 二级按钮名称
 */
const PCButtonClick = (first_button, second_button) => {
  sensors.track('PCButtonClick', {
    first_button,
    second_button,
  });
}

/**
 * 点击官网首页banner时触发
 * 官网_banner点击
 * @param {String} banner_name 代肝板块上线、游严选客服真假辨别
 * @param {String} banner_position index + 1
 */
const PCBannerClick = (banner_name, banner_position) => {
  sensors.track('PCBannerClick', {
    banner_name,
    banner_position: banner_position + '',
  });
}

/**
 * 点击官网首页公告消息运营位时触发
 * 官网_公告点击
 * @param {String} click_type 点击类型:更多、公告标题
 * @param {String} notice_name 公告名称:关于春节期间接待工作延误的致歉
 */
const PCNoticeClick = (click_type, notice_name) => {
  sensors.track('PCNoticeClick', {
    click_type,
    notice_name,
  });
}

/**
 * 点击官网热门服务一级按钮/二级按钮时触发
 * 官网_热门服务点击
 * @param {String} first_button 一级按钮名称:游戏账号、账号估价、装备道具、账号回收
 * @param {String} second_button 二级按钮名称:天涯明月刀、剑灵、英雄联盟等
 */
const PCHotServiceClick = (first_button, second_button) => {
  sensors.track('PCHotServiceClick', {
    first_button,
    second_button,
  });
}

/**
 * 点击官网快捷导航icon时触发
 * 官网_快捷导航点击
 * @param {String} button_location 按钮位置:index + 1
 * @param {String} button_name 按钮名称:下载app，联系客服，售后案例，业务介绍，投诉建议，最近浏览，帮助中心，有奖问卷
 */
const PCNavigationBarClick = (button_location, button_name) => {
  sensors.track('PCNavigationBarClick', {
    button_location: button_location + '',
    button_name,
  });
}

//Part 11 账号点击和曝光
/**
 * 账号曝光时触发
 * 账号曝光
 * @param {String} current_page 当前页面
 * @param {Number} current_page_num 当前页数
 * @param {String} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} seller_id 卖方ID
 * @param {String} is_vendors 是否号商
 * @param {String} section_id 栏位id
 * @param {String} current_item_id 当前页面的账号id
 * @param {String} current_item_type 当前页面的账号类型
 * @param {String} exp_id 实验id
 * @param {String} strategy_id 策略id
 * @param {String} retrieve_id 召回id
 * @param {String} log_id 日志id
 * @param {Boolean} is_recommendation 是否在推荐栏位下
 */
const AccountShow = (current_page, current_page_num, product_id, game_name, game_id
  , seller_id, is_vendors, section_id, current_item_id, current_item_type
  , exp_id, strategy_id, retrieve_id, log_id, is_recommendation,) => {
  sensors.track('AccountShow', {
    current_page: current_page + '',
    current_page_num: current_page_num * 1,
    product_id: product_id + '',
    game_name,
    game_id: game_id + '',
    seller_id: seller_id + '',
    is_vendors: is_vendors || false,
    section_id: section_id || '',
    current_item_id: current_item_id || '',
    current_item_type: current_item_type || '',
    exp_id: exp_id || '',
    strategy_id: strategy_id || '',
    retrieve_id: retrieve_id || '',
    log_id: log_id || '',
    is_recommendation: is_recommendation || false,
  });
}

/**
 * 点击账号时触发
 * 账号点击
 * @param {String} current_page 当前页面
 * @param {Number} current_page_num 当前页数
 * @param {String} product_id 商品ID
 * @param {String} game_name 游戏名称
 * @param {String} game_id 游戏ID
 * @param {String} seller_id 卖方ID
 * @param {String} is_vendors 是否号商
 * @param {String} section_id 栏位id
 * @param {String} current_item_id 当前页面的账号id
 * @param {String} current_item_type 当前页面的账号类型
 * @param {String} exp_id 实验id
 * @param {String} strategy_id 策略id
 * @param {String} retrieve_id 召回id
 * @param {String} log_id 日志id
 * @param {Boolean} is_recommendation 是否在推荐栏位下
 */
const AccountClick = (current_page, current_page_num, product_id, game_name, game_id
  , seller_id, is_vendors, section_id, current_item_id, current_item_type
  , exp_id, strategy_id, retrieve_id, log_id, is_recommendation,) => {
  sensors.track('AccountClick', {
    current_page: current_page + '',
    current_page_num: current_page_num * 1,
    product_id: product_id + '' || '',
    game_name: game_name || '',
    game_id: game_id + '' || '',
    seller_id: seller_id + '' || '',
    is_vendors: is_vendors + '' || false,
    section_id: section_id + '' || '',
    current_item_id: current_item_id + '' || '',
    current_item_type: current_item_type || '',
    exp_id: exp_id + '' || '',
    strategy_id: strategy_id + '' || '',
    retrieve_id: retrieve_id + '' || '',
    log_id: log_id + '' || '',
    is_recommendation: is_recommendation || false,
  });
}


export default {
  RegisterSignPageView,
  SubRegister,
  AccSellView,
  SellGameSelect,
  AddProductBasicInformation,
  AddProductDetailInformation,
  VouchView,
  VouchGameSelect,
  AccRecycleView,
  RecycleGameSelect,
  VendorsSelect,
  AccValuationView,
  ValuationGameSelect,
  AddValuationInformation,
  SubmitValuationSuccess,
  SellClick,
  ContinueValuationClick,
  AllGameView,
  BuyGameSelect,
  ProductTypeSelect,
  NormalScreen,
  AdvancedScreen,
  SellSincereScreen,
  PriceScreen,
  TopAccScreen,
  ProductDetailView,
  ProductDetailOperation,
  ConsultCustomer,
  CustomerServiceReply,
  GameSearchClick,
  SearchResultClick,
  ShareSuccess,
  ShareUrlClick,
  SharedClick,
  PCButtonClick,
  PCBannerClick,
  PCNoticeClick,
  PCHotServiceClick,
  PCNavigationBarClick,
  AccountShow,
  AccountClick,
}
